import React, { Component } from "react";
import '../styles/header.css';

class Header extends Component {

    render() {
        return (
            <div>
                <h1>This is the header</h1>
            </div>
        )
    }

}

export default Header;